import { trigger, state, style, transition, animate } from '@angular/animations';

const animHeaderState = trigger('animHeaderState', [
    state('opened', style({ opacity: 1 })),
    state('closed', style({ 'height': '0px', opacity: 0 })),
    transition('closed => opened', [animate('500ms ease-in')]),
    transition('opened => closed', animate('100ms ease-out'))
])

export { animHeaderState }